"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import { Ingredients, getEan } from "../../../Ingredients/Ingredients";
import { Product, RuntimeConfig } from "../../../../types/types";
import { useSkinMatchStatus } from "../../../../hooks/useSkinMatch/useSkinMatch";
import { useVariant } from "../../../../hooks/useVariant/useVariant";

type Props = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  open?: boolean;
};

export const PRODUCT_INGREDIENTS_ACCORDION_INSTANCE_NAME = "ingredients";

export function ProductIngredientsAccordionUI({
  product,
  runtimeConfig,
}: Props) {
  const { variant } = useVariant(product);
  const ean = getEan(variant);
  const skinMatchLookUpBaseUrl = runtimeConfig?.skinMatchLookUpBaseUrl;
  const skinMatchLookUpData = useSkinMatchStatus(ean, skinMatchLookUpBaseUrl);

  if (
    skinMatchLookUpData &&
    skinMatchLookUpData.status == "Done" &&
    skinMatchLookUpData.data.skinMatchStatus
  ) {
    return (
      <Accordion
        id="accordion-ingredients"
        data-testid="accordion:ingredients"
        label="Ingredients"
        animated={true}
        instanceName={PRODUCT_INGREDIENTS_ACCORDION_INSTANCE_NAME}
        responsive
        open={open}
      >
        <Ingredients product={product} runtimeConfig={runtimeConfig} />
      </Accordion>
    );
  } else {
    return null;
  }
}
